export function subcategoryToReasonTraning(subcategory) {
    if (subcategory === 1 || subcategory === 7 || subcategory === 9) return "اخصائي الامن والسلامة";
    if (subcategory === 3 || subcategory === 13|| subcategory === 2) return "مشرف المنطقة";
    if (subcategory === 3 || subcategory === 7) return "مشرف. امن وسلامة";
    if (subcategory === 4 || subcategory === 6) return "المتعهد";
    if (subcategory === 12 || subcategory === 5) return "معالجة البيانات";
    if (subcategory === 10) return " مدير ادارة الامن والسلامة";
    if (subcategory === 11) return "تم الاعتماد";
    if (subcategory === 9) return "المدرب";
    return "غير معروف";
  }
  
  
  export function subcategoryToReasonAccident(subcategory) {
    if (subcategory === 1) return "مسودة";
    if (subcategory === 2 || subcategory === 6) return "مشرف المنطقة";
    if (subcategory === 3 || subcategory === 7) return "مشرف. امن وسلامة";
    if (subcategory === 4 || subcategory === 8) return "مدير منطقة";
    if (subcategory === 5 || subcategory === 9) return "بلاغ مقفل";
    return "غير معروف";
  }
  

  export function subcategoryToReasonServey(subcategory) {
    if (subcategory === 1) return "المتعهد";
    if (subcategory === 2 ) return "الاعتماد - مدير المنطقة";
    if (subcategory === 3 ) return "الاعتماد - تم الاعتماد ";

    return "غير معروف";
  }